import { LineOfCreditHistorySuccess } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { useCallback } from 'react';
import FetchLineOfCreditHistory from 'services/graphql/queries/FetchLineOfCreditHistory';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface VlocHistoryTypes {
  vlocData?: LineOfCreditHistorySuccess;
  errorModel?: {
    screenType: ErrorScreenType;
    messageHeadline: string;
    messageBody: string;
    primaryButton: {
      title: string;
      onPress: () => void;
    };
  } | null;
  loading: boolean;
  refetch: () => void;
}

const useVlocHistory = (accountId: string): VlocHistoryTypes => {
  const router = useRouter();
  const [{ data, error, fetching }, executeQuery] = useQuery<{
    lineOfCreditHistory: LineOfCreditHistorySuccess;
  }>({
    query: FetchLineOfCreditHistory,
    variables: { id: accountId },
    requestPolicy: 'cache-and-network',
  });

  const { defaultTitle, cancelButtonTitle } = useDefaultErrorStrings();

  const cancel = () => {
    router.back();
  };

  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = error?.message
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: error.message,
        ...buttons,
      }
    : null;

  const fetchAccountDetails = useCallback(() => {
    executeQuery({ id: accountId });
  }, [executeQuery, accountId]);

  return {
    vlocData: data?.lineOfCreditHistory,
    errorModel: errorModel,
    loading: fetching,
    refetch: fetchAccountDetails,
  };
};

export default useVlocHistory;
